import DropdownContainer from "../../../Components/UiKits/Dropdown/DropdownContainer";

const Dropdown = () => {
  return <DropdownContainer />;
};

export default Dropdown;
